<template>
  <div class="coupon-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'email_template_trigger_list' }" class="float-left mr-1 main-link">{{$t('notification.manage_email_trigger')}}</router-link> / {{$t('coupon.detail')}}
                </h3>
              </strong>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">

          <!-- Basic information -->
          <b-card header-tag="header" footer-tag="footer" class="header">
            <!-- <div slot="header">
            </div> -->
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <!-- <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{ 'Client ID' }}</legend>
                    <div class="col-sm-10" >
                      <b-form-select
                        v-model="item.client_id" v-bind:value="item.client_id"
                        :options="client_ids" v-bind:placeholder="'Choose one'"
                        :state="!$v.item.client_id.$invalid">
                      </b-form-select>
                      <b-form-invalid-feedback :id="'client-id-feedback'">
                        <p class="help is-danger" v-if="!$v.item.client_id.required">{{ $t('message.required_filed') }}</p>
                      </b-form-invalid-feedback>
                    </div>
                  </div> -->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{ $t('email_template_triggers.datatable.trigger_id') }}</legend>
                    <div class="col-sm-10" >
                      <b-form-input
                          class="form-control"
                          v-model="item.trigger_id"
                          :state="!$v.item.trigger_id.$invalid && !$v.item.trigger_id.regex.$invalid"
                          :disabled="isCreate() == false" />
                      <b-form-invalid-feedback :id="'trigger-id-feedback'">
                        <p class="help is-danger" v-if="!$v.item.trigger_id.required">{{ $t('message.required_filed') }}</p>
                        <p class="help is-danger" v-if="!$v.item.trigger_id.regex">{{ $t('email_template.message.trigger_id_format_invalid') }}</p>
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{ $t('email_template_triggers.datatable.template_name') }}</legend>
                    <div class="col-sm-10" >
                      <b-form-select
                        v-model="item.template_id" v-bind:value="item.template_id"
                        :options="templates" v-bind:placeholder="$t('menu.choose_option')"
                        :state="!$v.item.template_id.$invalid">
                      </b-form-select>
                      <b-form-invalid-feedback :id="'template-id-feedback'">
                        <p class="help is-danger" v-if="!$v.item.template_id.required">{{ $t('message.required_filed') }}</p>
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{ $t('email_template_triggers.datatable.service') }}</legend>
                    <div class="col-sm-10" >
                      <b-form-select
                        v-model="item.service" v-bind:value="item.service"
                        :options="services" v-bind:placeholder="$t('menu.choose_option')"
                        :state="!$v.item.service.$invalid">
                      </b-form-select>
                      <b-form-invalid-feedback :id="'service-id-feedback'">
                        <p class="help is-danger" v-if="!$v.item.service.required">{{ $t('message.required_filed') }}</p>
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Basic information -->

          <div slot="footer" class="card-footer">
            <router-link :to="{ name: 'email_template_trigger_list', query: {rollback: 1}}" class="btn border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</router-link>
            <div class="btn-save">
              <b-button :disabled="!validTriggerId || !validTemplateId || !validService" variant="success"
                        v-on:click="save()">{{ $t('common.save')}}
              </b-button>
            </div>
          </div>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, helpers} from 'vuelidate/lib/validators'

  let vm = null

  const REQUIRED_FIELD = [
    // 'client_id',
    'trigger_id',
    'template_id',
    'service',
    'updated_by',
  ]
  const HTML_FIELD = []

  export default {
    props: {
      uuid: {
        type: [String, Number],
        required: true,
        default: 'create'
      }
    },
    components: {},
    data: function () {
      return {
        TRIGGER_ID_REGEX: /^[a-z]+(_[a-z]+)*$/,
        authUser:  this.$auth.user().user_info.user,
        session: {
          client_uuid: String(localStorage.getItem('clientID')),
          client_id: null,
          lang: String(this.$session.get('lang') || 'en'),
        },
        update: false,
        isProcessing: false,
        // client_ids: [
        //   {
        //     value: null, text: 'Choose one',
        //   }
        // ],
        templates: [],
        services: this.$const.GMS_SERVICES,
        item: {
          uuid: null,
          // client_id: null,
          trigger_id: '',
          template_id: '',
          service: '',
          updated_by: ''
        },
        basicInformationStatus: true,
        languages: Object.keys(this.$i18n.messages),
        validClientId: false,
        validTriggerId: false,
        validTemplateId: false,
        validService: false,
      }
    },
    mixins: [
      validationMixin
    ],
    computed: {
      rules () {
        return {
          // client_id: {
          //   required
          // },
          trigger_id: {
            required,
            regex: helpers.regex('triggerId', this.TRIGGER_ID_REGEX)
          },
          template_id: {
            required
          },
          service: {
            required
          }
        }
      }
    },
    validations () {
      return {
        item: this.rules
      }
    },
    methods: {
      isCreate () {
        return this.uuid == 'create' || this.uuid == undefined
      },
      updateBasicInformationStatus () {
        this.basicInformationStatus = !this.basicInformationStatus
      },
      getEmailTemplates () {
        const vm = this;
        vm.axios.notification.getEmailTemplateList(`page=1&limit=10000&client_id=${vm.session.client_id}&active=1`,
          function(response){
            vm.templates = response.data.data.items.map((item) => {
              return {text: item.name[vm.session.lang], value: item.id}
            })
          })
        vm.templates = []
      },
      getDetails () {
        const vm = this
        vm.axios.notification.getEmailTemplateTriggerDetails({ uuid: vm.uuid }, function (response) {
          if (response.status === 200) {
            vm.item = response.data.data.item
          }
        })
      },
      // getMyClients () {
      //   const vm = this;
      //   vm.axios.tenant.getClientsByMe(respone => {
      //     if (respone.status === 200) {
      //       const data = respone.data.data.items
      //       vm.client_ids = [
      //         ...vm.client_ids,
      //         ...data.map((item) => {
      //           return { text: item.name, value: item.uuid }
      //         })
      //       ]
      //     }
      //   }, error => { console.log(error) })
      // },
      save () {
        const vm = this
        vm.$bus.$emit('loading', 'block')
        vm.isProcessing = true
        const savedData = vm._.cloneDeep({
          ...vm.item,
          client_id: vm.session.client_id,
          updated_by: vm.$auth.user().user_info.user.email,
        })
        if (vm.isCreate()) {
          delete savedData.uuid
          vm.axios.notification.createEmailTemplateTrigger(savedData, function (response) {
            vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
            vm.isProcessing = false
            vm.$router.push({name: 'email_template_trigger_list'})
          }, function () {
            vm.isProcessing = false
          }, { email: vm.authUser.email })
        } else {
          delete savedData.updated_at
          delete savedData.created_at
          vm.axios.notification.updateEmailTemplateTrigger(savedData, function (response) {
            vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
            vm.isProcessing = false
          }, function () {
            vm.isProcessing = false
          }, { email: vm.authUser.email })
        }
        vm.$bus.$emit('loading', 'none')
      },
      validateField (fieldName) {
        let langs = vm.display_languages
        let result = true
        let data = vm.item[fieldName]
        for (let l of langs) {
          vm[`multiLang${fieldName[0].toUpperCase()}${fieldName.slice(1)}`][l] = vm.validateData(data[l], HTML_FIELD.includes(fieldName))
          result = result && vm[`multiLang${fieldName[0].toUpperCase()}${fieldName.slice(1)}`][l]
        }

        return result
      },
      validateData (data, isHtml) {
        let result = false

        if (data !== undefined && data != '') {
          let str = data.replaceAll(' ', '')
          if (isHtml) {
            str = str.replace(/<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, '').trim()
          }
          result = true
          if(0 == str.length) {
            result = false
          }
        }

        return result
      },
      validateRequireField () {
        vm.validData = true
        for(let f of REQUIRED_FIELD) {
         vm[`valid${f[0].toUpperCase()}${f.slice(1)}`] = vm.validateField(f)
        }
      }
    },
    created: function () {
      vm = this
      vm.xToken = this.$auth.user().token
      vm.session.client_id = Number(this._.get(vm.$store.getters.config, 'base.id', 0))

      // Get email templates
      this.getEmailTemplates()
      
      // Get user clients list and bind them to the selector for client_id
      // this.getMyClients()

      // Get email template trigger details
      if (vm.uuid != 'create' && vm.uuid !== undefined) {
        vm.getDetails()
      }
    },
    watch: {
      // 'item.client_id': {
      //   handler (clientId) {
      //     const vm = this;
      //     if (clientId) {
      //       vm.validClientId = true
      //     } else {
      //       vm.validClientId = false
      //     }
      //   },
      //   deep: true
      // },
      'item.trigger_id': {
        handler (triggerId) {
          const vm = this;
          if (triggerId) {
            if (!vm.TRIGGER_ID_REGEX.test(triggerId)) {
              vm.validTriggerId = false
            } else {
              vm.validTriggerId = true
            }
          } else {
            vm.validTriggerId = false
          }
        },
        deep: true
      },
      'item.template_id': {
        handler (templateId) {
          const vm = this;
          if (templateId) {
            vm.validTemplateId = true
          } else {
            vm.validTriggerId = false
          }
        },
        deep: true
      },
      'item.service': {
        handler (service) {
          const vm = this;
          if (service) {
            vm.validService= true
          } else {
            vm.validService = false
          }
        },
        deep: true
      }
    },
    updated: function () {
      if (vm.id != 'create' && vm.uuid !== undefined &&
        !vm.isProcessing) {
        vm.item.uuid = vm.uuid
      }
    },
    mounted: function () {
      if (vm.id != 'create' && vm.uuid !== undefined &&
        !vm.isProcessing) {
        vm.item.uuid = vm.uuid
      }
    }
  }
</script>

<style>
  .coupon-form input,
  .coupon-form textarea,
  .coupon-form select,
  .coupon-form .multiselect__tags {
      border-radius: 4px !important;
  }

  .multiselect__tags{
      border-radius: 0 !important;
  }

  .is-invalid .multiselect__tags {
      border-color: #f86c6b;
  }

  .coupon-form .switch-success > .switch-input:checked ~ .switch-label,
  .coupon-form .btn-success,
  .coupon-form .draw-map,
  .coupon-form .btn-primary
  {
    background: #0086FF !important;
    border-color: #0086FF !important;
    border-radius: 3px;
  }

  .coupon-form .btn-secondary{
    border-radius: 3px;
  }

  /*checkbox style*/
  .coupon-form  .form-check:after,
  .coupon-form .form-check:before {
      content: " ";
      display: table;
      content: "";
      line-height: 0;
  }

  .coupon-form .form-check input[type="checkbox"] {
      opacity: 0;
      z-index: 1;
      cursor: pointer;
  }

  .coupon-form .form-check label {
      min-height: 20px;
      padding-left: 15px;
      cursor: pointer;
      display: inline-block;
      max-width: 100%;
      margin-bottom: 5px;
      font-weight: normal;
      vertical-align: middle;
      position: relative;
  }

  .coupon-form .form-check label::before {
      border-radius: 50%;
      content: "";
      display: inline-block;
      position: absolute;
      width: 20px;
      height: 20px;
      left: 0;
      margin-left: -10px;
      border: 1px solid #cccccc;
      background-color: #fff;
      -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::before {
      background-color: #0086FF;
      border-color: #0086FF;
  }

  .coupon-form .form-check .form-check-input:disabled ~ label {
    cursor: not-allowed;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::after {
      font-family: 'FontAwesome';
      content: "\f00c";
      color: #fff;
  }

  .coupon-form .form-check label::after {
      display: inline-block;
      position: absolute;
      width: 16px;
      height: 16px;
      left: 0;
      top: 0;
      margin-left: -10px;
      padding-left: 4px;
      padding-top: 1px;
      font-size: 12px;
      color: #0086FF;
  }
  /*checkbox style*/
  .coupon-form #customize-field .col-sm-10
  {
    padding-left: 8px;
  }

  .coupon-form .form-check-inline{
    margin-right: 1rem;
  }

  .coupon-form .modal-lg{
    max-width: 95%;
    margin-top: 0;
  }

  .coupon-form .modal-body{
    padding: 0 1rem;
  }

  .coupon-form .padding-none{
    padding: 0;
  }

  .applicable-store label span{
    width: 48px;
  }

  .applicable-store select{
    margin-right: 20px;
  }
  .not_apply_date .mx-input-append {
    display: none!important;
  }

  .not_apply_date .mx-calendar-header {
    width: 100%!important;
  }
  .not_apply_date .mx-calendar-content {
    width : 100%!important;
    height: 100%!important;
  }
  .not_apply_date .mx-time-list{
    height: 225px;
  }

</style>

<style scoped>
  #application_result_content .gray-background{
    border-radius: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  #application_result_content .gray-light-background{
    border-radius: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  /*input file */
  .file-select > .select-button {
    padding: 7px;
    color: white;
    border-radius: .2rem;
    text-align: center;
    font-weight: bold;
    background: #0086FF !important;
    border-color: #0086FF !important;
    cursor: pointer;
    margin-top: 3px;
  }

  .file-select > input[type="file"] {
    display: none;
  }
  /*input file*/

  .applicable-store input{
    margin-top: 5px;
  }

  .switch-custom{
    max-width: 5.3%;
  }

  .table-bordered{
    margin-top: 10px;
  }

  .table-bordered thead{
    background-color: #E1E6EB;
  }

  .table-bordered tbody{
    background-color: #F4F6F8;
  }

  .table-bordered th{
    border: none;
  }

  .table-bordered .center{
    text-align: center;
  }

  .col-sm-2-custom{
    flex: 0 0 12.66667%;
    margin-top: 2px;
    text-align: center;
  }

  .col-sm-2-custom-display-inline{
    flex: 0 0 12.66667%;
    margin-top: 2px;
    text-align: center;
    display: inline-flex;
  }

  .coupon-form .btn-save{
    float: right;
    margin-right: 22px;
  }

  .coupon-form .switch.switch-icon{
    margin-top: 5px;
  }

  .coupon-form .header-custom{
    margin-top: 15px;
  }

  .coupon-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .coupon-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .coupon-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .coupon-form .header-custom-switch .active{
    float: right;
  }

  .coupon-form div.header,
  .coupon-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .coupon-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .coupon-form .add-more{
    padding-left: 0;
  }

  .coupon-form .add-more{
    color: #0086FF;
    cursor: pointer;
  }

  .coupon-form .add-more .fa{
    margin-right: 10px;
    font-size: 15px;
    border-radius: 50%;
    border: 1px solid #0086FF;
    width: 18px;
    height: 17px;
    color: #0086FF;
    padding-left: 2px;
  }

  .gray-background .form-control{
    /*padding: 8px;*/
    border: 1px solid gray;
  }

  .gray-background{
    background: #E1E6EB;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DDE2E8;
  }

  .gray-light-background{
    background: #F4F6F8;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DDE2E8;
  }

  .gray-background .row{
    margin-bottom: 0px;
  }

  .remark .btn-danger{
    margin-top: 7px;
    background-color: #fff;
  }

  .gray-light-background .btn-danger,
  .table-bordered .btn-danger{
    background-color: #F4F6F8;
  }

  .table-bordered .btn-danger{
    margin-top: 4px;
  }

  .gray-background .btn-danger{
    background-color: #E1E6EB;
  }

  .gray-background .btn-danger .fa,
  .gray-light-background .btn-danger .fa,
  .remark .btn-danger .fa,
  .table-bordered .btn-danger .fa{
    color: #0086FF;
    font-size: 20px;
  }

  .gray-background .col-sm-10,
  .gray-light-background .col-sm-10,
  .gray-light-background .col-sm-5{
    padding-left: 5px;
  }

  .margin-top20{
    margin-top: 20px;
  }

  .margin-bottom10{
    margin-bottom: 10px;
  }

  .clear-both{
    margin-bottom: 15px;
  }

  .card{
    margin-bottom: 0;
  }

  .coupon-image{
    margin: 0;
    padding: 0;
    display: inline-flex;
  }

  .coupon-image img{
    width: 100%;
  }

  .coupon-properties legend{
    width: auto;
    resize: both;
  }

  .coupon-properties .check-is-member{
    max-width: 16%;
  }

  .preview-image {
    width: 100%;
  }

  .font-size-inherit {
    font-size: inherit;
  }

</style>



// WEBPACK FOOTER //
// src/views/admin/email-template/TriggerForm.vue